<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="assets/svg/index.svg">
    </div>
</div>